import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useApiKeys } from '../../hooks';
import ProfileTemplate from '../ProfileTemplate';

export default function ApiKeyDetails() {
  const { apiKeys, getApiKeys } = useApiKeys();
  const { id } = useParams<{ id: string }>();

  const apiKey = apiKeys.find(apiKey => apiKey.id === id);

  useEffect(() => {
    getApiKeys();
  }, [getApiKeys]);

  return <ProfileTemplate className="api-key-details">
    {
      apiKey && <div className="align-items-center p-3 rounded shadow mt-4">
        <div className="media-body content ml-3">
          <h4 className="title mb-0">{apiKey.name}</h4>
          <p className="text-muted mb-0">{apiKey.description}</p>
          <br />
          <p className="text-muted mb-0">
            Status <span className={apiKey.active ? "text-primary" : "text-danger"}>
              <strong className="text-uppercase">{apiKey.active ? 'active' : 'not active'}</strong>
            </span>
          </p>
          <br />
          <div className="d-flex">
            <div className="text-muted mr-5">
              <div>Key Id</div>
              <div>Key Secret</div>
            </div>
            <div>
              <div>{apiKey.keyId}</div>
              <div>{apiKey.keySecret}</div>
            </div>
          </div>
          <br />
          <div>
            <div className="text-muted">Your application can be authorized by adding a HTTP header below to every request which calls UTU API</div>
            <div>Authorization: apiKey {apiKey.keyId}:{apiKey.keySecret}</div>
          </div>
        </div>
      </div>
    }
  </ProfileTemplate>
}